// extracted by mini-css-extract-plugin
export default {"sidebarNavMenu":"UserSidebarMenu_sidebarNavMenu__KidXc","active":"UserSidebarMenu_active__Av-6j","emailVerifyWrap":"UserSidebarMenu_emailVerifyWrap__jxezn"};